import script from "./OrderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderCard.vue?vue&type=script&setup=true&lang=ts"

import "./OrderCard.vue?vue&type=style&index=0&id=3a32669d&scoped=true&lang=css"
import "./OrderCard.vue?vue&type=style&index=1&id=3a32669d&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a32669d"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn,QIcon,QInput,QField});
